$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});

$(function(){
  /*swiper スライド*/
  var swiper = new Swiper('.swiper-container2', {
    navigation: { 
      nextEl: '.swiper-button-next2',
      prevEl: '.swiper-button-prev2',
    },
    pagination: {   
      el: '.swiper-pagination2',    
      type: 'bullets',   
      clickable: true,
    },
    loop: true,  
    observer: true,
    observeParents: true,
    /*loopedSlides: 3,*/
    slidesPerView: 1,
		
		/*slideToClickedSlide: true,*/
		spaceBetween: 20,
		/*slidesPerGroup: 1,*/
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 2,
			}
		}
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
	});
});

$(function () {
  $('.accordion-contents dt').click(function() {
    $(this).next('dd').slideToggle('fast'),
    $(this).toggleClass("open");
  });
});

  /*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 300) {
   $('.follow-area').fadeIn(400);
   } else {
    $('.follow-area').fadeOut(400);
  }
  });

/*↓複数用*/
function copyToClipboard(index) {
            // コピー対象をJavaScript上で変数として定義する
            var copyTarget = document.getElementById("copyTarget" + index);

            // コピー対象のテキストを選択する
            copyTarget.select();

            // 選択しているテキストをクリップボードにコピーする
            document.execCommand("Copy");

            // コピーをお知らせする
            alert("クーポンコードをコピーしました。 : " + copyTarget.value);
        }

$(function(){
    $('.js-modal-open').on('click',function(){
        $('.js-modal').fadeIn();
        return false;
    });
    $('.js-modal-close').on('click',function(){
        $('.js-modal').fadeOut();
        return false;
    });
  });

$(function(){
  /*swiper スライド ランキング用*/
  var swiper = new Swiper('.swiper-container3', {
    navigation: { 
      nextEl: '.swiper-button-next3',
      prevEl: '.swiper-button-prev3',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 5,
			}
		}
	});
  
    var swiper = new Swiper('.swiper-container4', {
    navigation: { 
      nextEl: '.swiper-button-next4',
      prevEl: '.swiper-button-prev4',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 5,
			}
		}
	});
  
  var swiper = new Swiper('.swiper-container5', {
    navigation: { 
      nextEl: '.swiper-button-next5',
      prevEl: '.swiper-button-prev5',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 5,
			}
		}
	});
  
});

$(function(){
  /*swiper スライド*/
  var swiper = new Swiper('.swiper-container-scene', {
    navigation: { 
      nextEl: '.swiper-button-next-scene',
      prevEl: '.swiper-button-prev-scene',
    },
    loop: true,  
    /*observer: true,
    observeParents: true,*/
    slidesPerView: 1.2,
		/*slideToClickedSlide: true,*/
		spaceBetween: 6,
    centeredSlides: true, // アクティブなスライドを中央にする
      speed: 1000, // 少しゆっくり(デフォルトは300)
  autoplay: { 
    delay: 1500, // 1.5秒後に次のスライド
  },
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.4,
        spaceBetween: 20,
			}
		}
    /*autoplay: {
      disableOnInteraction: false
    },*/
	});
});


$(function(){
  /*swiper スライド インスタグラム投稿用*/
  var swiper = new Swiper('.swiper-container-inst', {
    navigation: { 
      nextEl: '.swiper-button-next-inst',
      prevEl: '.swiper-button-prev-inst',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 16,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 5,
			}
		}
	});
  	});

$(function(){
    const modalWrapOpen = function(e) {
  const dataModalOpen = e.currentTarget.dataset.modalOpen;
  Array.from(document.querySelectorAll('.works_modal_wrapper')).forEach((e, i) => {
    if(e.getAttribute('data-modal') === dataModalOpen){
      e.classList.toggle('is_open');
    }
  })
}
    
Array.from(document.querySelectorAll('.works_modal_open')).forEach((modalOpenElement) => {
  modalOpenElement.addEventListener('click', modalWrapOpen);
})

const modalCloseAction = function(e) {
  const targetModal = e.currentTarget.closest('.works_modal_wrapper');
  targetModal.classList.toggle('is_open')
};

Array.from(document.querySelectorAll('.works_modal_close')).forEach((modalCloseElement) => {
  modalCloseElement.addEventListener('click', modalCloseAction)
})
  });


$(function(){
  var swiper = new Swiper('.swiper-container-sale01', {
    navigation: { 
      nextEl: '.swiper-button-next-sale01',
      prevEl: '.swiper-button-prev-sale01',
    },
    pagination: {
    el: '.swiper-pagination01',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale02', {
    navigation: { 
      nextEl: '.swiper-button-next-sale02',
      prevEl: '.swiper-button-prev-sale02',
    },
    pagination: {
    el: '.swiper-pagination02',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale03', {
    navigation: { 
      nextEl: '.swiper-button-next-sale03',
      prevEl: '.swiper-button-prev-sale03',
    },
    pagination: {
    el: '.swiper-pagination03',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.12, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.4,
        spaceBetween: 20,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale04', {
    navigation: { 
      nextEl: '.swiper-button-next-sale04',
      prevEl: '.swiper-button-prev-sale04',
    },
    pagination: {
    el: '.swiper-pagination04',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.12, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.4,
        spaceBetween: 20,
			}
		}
	});
  });


  /*2512セールで追加*/
$(function(){
  var swiper = new Swiper('.swiper-container-sale05', {
    navigation: { 
      nextEl: '.swiper-button-next-sale05',
      prevEl: '.swiper-button-prev-sale05',
    },
    pagination: {
    el: '.swiper-pagination05',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale06', {
    navigation: { 
      nextEl: '.swiper-button-next-sale06',
      prevEl: '.swiper-button-prev-sale06',
    },
    pagination: {
    el: '.swiper-pagination06',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale07', {
    navigation: { 
      nextEl: '.swiper-button-next-sale07',
      prevEl: '.swiper-button-prev-sale07',
    },
    pagination: {
    el: '.swiper-pagination07',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale08', {
    navigation: { 
      nextEl: '.swiper-button-next-sale08',
      prevEl: '.swiper-button-prev-sale08',
    },
    pagination: {
    el: '.swiper-pagination08',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 1.4,
			}
		}
	});
  });

  
  /*サムネ付きスライダー 2602追加*/
  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-01", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-01", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-01',
      prevEl: '.swiper-button-prev-01',
    },
    breakpoints: {
			 //768px以上の場合
/*			768: {

			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});
  
  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-02", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-02", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-02',
      prevEl: '.swiper-button-prev-02',
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});
  
  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-03", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-03", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-03',
      prevEl: '.swiper-button-prev-03',
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});
  
  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-04", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-04", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-04',
      prevEl: '.swiper-button-prev-04',
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-05", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-05", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-05',
      prevEl: '.swiper-button-prev-05',
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});

  window.addEventListener("DOMContentLoaded", () => {
  // サムネイルのスライダー
  const thumbnail = new Swiper(".thumbnail-06", {
    freeMode: true,
    slidesPerView: 5,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  // メインのスライダー
  const slider = new Swiper(".slider-06", {
    thumbs: {
      swiper: thumbnail,
    },
    navigation: { 
      nextEl: '.swiper-button-next-06',
      prevEl: '.swiper-button-prev-06',
    },
    breakpoints: {
			 //768px以上の場合
			/*768: {
				
			}*/
		},
    disabledClass: '.swiper-button-disabled',
    effect: 'fade',
    speed: 1000,
    spaceBetween: 10,
    loop: false,
    /*loop: true,*/ 
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
  });
});


/*スライダー 2605追加*/
$(function(){
  var swiper = new Swiper('.swiper-container-sale-item01', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item01',
      prevEl: '.swiper-button-prev-sale-item01',
    },
    pagination: {
    el: '.swiper-pagination-item01',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item02', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item02',
      prevEl: '.swiper-button-prev-sale-item02',
    },
    pagination: {
    el: '.swiper-pagination-item02',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item03', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item03',
      prevEl: '.swiper-button-prev-sale-item03',
    },
    pagination: {
    el: '.swiper-pagination-item03',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item04', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item04',
      prevEl: '.swiper-button-prev-sale-item04',
    },
    pagination: {
    el: '.swiper-pagination-item04',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item05', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item05',
      prevEl: '.swiper-button-prev-sale-item05',
    },
    pagination: {
    el: '.swiper-pagination-item05',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item06', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item06',
      prevEl: '.swiper-button-prev-sale-item06',
    },
    pagination: {
    el: '.swiper-pagination-item06',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item07', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item07',
      prevEl: '.swiper-button-prev-sale-item07',
    },
    pagination: {
    el: '.swiper-pagination-item07',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item08', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item08',
      prevEl: '.swiper-button-prev-sale-item08',
    },
    pagination: {
    el: '.swiper-pagination-item08',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

  $(function(){
  var swiper = new Swiper('.swiper-container-sale-item09', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item09',
      prevEl: '.swiper-button-prev-sale-item09',
    },
    pagination: {
    el: '.swiper-pagination-item09',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item10', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item10',
      prevEl: '.swiper-button-prev-sale-item10',
    },
    pagination: {
    el: '.swiper-pagination-item10',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

  $(function(){
  var swiper = new Swiper('.swiper-container-sale-item11', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item11',
      prevEl: '.swiper-button-prev-sale-item11',
    },
    pagination: {
    el: '.swiper-pagination-item11',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

/*スライダー 260516追加*/
$(function(){
  var swiper = new Swiper('.swiper-container-sale-item01add', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item01add',
      prevEl: '.swiper-button-prev-sale-item01add',
    },
    pagination: {
    el: '.swiper-pagination-item01add',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container-sale-item02add', {
    navigation: { 
      nextEl: '.swiper-button-next-sale-item02add',
      prevEl: '.swiper-button-prev-sale-item02add',
    },
    pagination: {
    el: '.swiper-pagination-item02add',
    clickable: true,
  },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 1,
    slidesPerView: 1.2, // 一度に表示する枚数
    centeredSlides: true, // アクティブなスライドを中央にする
		spaceBetween: 10,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 1.1,
        spaceBetween: 8,
			}
		}
	});
  });
